import type { PayloadAction } from '@reduxjs/toolkit';
import { createSlice } from '@reduxjs/toolkit';

import type { PartnerProductInsightsAPIPartner } from 'src/services/partner-product-insights-api/types/PartnerProductInsightsAPIPartner';
import { logger } from 'src/utils/serverLogger';
import { adaptPartnerContentToStore } from './adapters/adaptPartnerContentToStore';
import { adaptPartnerInsightsForStore } from './adapters/adaptPartnerInsightsForStore';
import { requestPartnerContent } from './thunks';
import type { PartnerState } from './types';

export type { PartnerState } from './types';

export const initialState: PartnerState = {
  content: null,
  insights: null,
};

const partnerSlice = createSlice({
  name: 'partner',
  initialState,
  reducers: {
    setPartnerInsights: (
      state,
      { payload }: PayloadAction<PartnerProductInsightsAPIPartner | null>,
    ) => {
      state.insights = payload ? adaptPartnerInsightsForStore(payload) : null;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(requestPartnerContent.fulfilled, (state, { payload }) => {
        state.content = payload ? adaptPartnerContentToStore(payload) : null;
      })
      .addCase(requestPartnerContent.rejected, (state, action) => {
        logger.error('Error requesting partner content', action.error);
        state.content = null;
      });
  },
});

export const { setPartnerInsights } = partnerSlice.actions;
export const { reducer } = partnerSlice;
